<template>
  <div class="box" id="header">
    <div class="header">
      <a href="https://www.ciftis.org/">
        <img src="@/assets/img/header.png" alt="" />
      </a>
      <div class="ssRight">
        <ul class="zh">
          <li :clstag="`newscenter|keycount|headerBanner|click-search`">
            <el-input
              v-model="searchValue"
              placeholder="请输入"
              class="news-center-search"
              @blur="() => (searchValue = searchValue.trim())"
              @keyup.enter.native="toSearch"
            >
              <i
                @click="toSearch"
                slot="suffix"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
          </li>
          <li
            @click="setLang('zh-CN')"
            :clstag="`newscenter|keycount|headerBanner|click-zh`"
            :class="u_cookie == 'zh-CN' || u_cookie == '' ? 'h_active' : ''"
          >
            中文(简体)
          </li>
          &nbsp; | &nbsp;
          <li
            @click="setLang('en-US')"
            :clstag="`newscenter|keycount|headerBanner|click-en`"
            :class="u_cookie == 'en-US' ? 'e_active' : ''"
          >
            English
          </li>
        </ul>
        <div class="user" v-if="user">
          <p>{{ ciftis_user_name }} <i></i></p>
          <ul class="user_masage">
            <li>
              <a :href="accountUrl" target="_blank">{{ $t('账户中心') }}</a>
            </li>
            <li>
              <a :href="backUrl" target="_blank">{{ $t('运营平台') }}</a>
            </li>
            <li>
              <a href="javascript:" @click="out('zh-CN')">{{
                $t('退出登录')
              }}</a>
            </li>
          </ul>
        </div>
        <p
          class="assets"
          @click="login"
          :clstag="`newscenter|keycount|headerBanner|click-login`"
          v-if="!user"
        >
          <span :title="$t('媒体登录')">{{ $t('媒体登录') }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  components: {},
  props: {},
  data() {
    return {
      user: false,
      ciftis_user_name: '',
      u_cookie: '',
      accountUrl: '',
      backUrl: '',
      officailUrl: '',
      searchValue: ''
    }
  },
  computed: {},
  watch: {},
  methods: {
    toSearch() {
      this.$emit('search', this.searchValue)
      this.searchValue = ''
    },
    login() {
      window.open(process.env.VUE_APP_LOGIN_URL)
    },
    setLang(_cookie) {
      if (_cookie === this.u_cookie) {
        return
      } else {
        Cookie.set('ciftis_site_lang', _cookie, {
          domain: process.env.VUE_APP_COOKIE_DOMAIN
        })
        if (window.location.pathname == '/consult') {
          this.$router.push({
            path: '/home'
          })
          // window.location.reload()
        } else {
          window.location.reload()
        }
      }
    },
    out(_cookie) {
      Cookie.remove('ciftis_account_name', {
        domain: process.env.VUE_APP_COOKIE_DOMAIN
      })
      Cookie.remove('ciftis_user_name', {
        domain: process.env.VUE_APP_COOKIE_DOMAIN
      })
      Cookie.remove('ciftis_at', {
        domain: process.env.VUE_APP_COOKIE_DOMAIN
      })
      Cookie.set('ciftis_site_lang', _cookie, {
        domain: process.env.VUE_APP_COOKIE_DOMAIN
      })
      window.location.href = this.officailUrl
    }
  },
  created() {
    this.accountUrl = process.env.VUE_APP_ACCOUNT_URL
    this.backUrl = process.env.VUE_APP_BACK_URL
    this.officailUrl = process.env.VUE_APP_OFFICIAL_URL
  },
  mounted() {
    var ciftis_user_name = Cookie.get('ciftis_user_name')
    if (ciftis_user_name) {
      this.user = true
      this.ciftis_user_name = ciftis_user_name
    } else {
      this.user = false
    }
    this.u_cookie = Cookie.get('ciftis_site_lang')
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style lang="scss" scoped>
.news-center-search {
  ::v-deep .el-input__inner {
    width: 160px;
    height: 38px;
    border-radius: 20px;
    border: 1px solid #e6e6e6;
    color: #666;
    font-size: 14px;
    padding: 0 10px;
  }
}
.box {
  width: 100%;
  height: 100px;
  background: #fff;
}
.header {
  width: 1200px;
  height: 100px;
  display: flex;
  padding-top: 20px;
  // padding: 30px 0;
  margin: 0 auto;
  // background: #fff;
  justify-content: space-between;
  img {
    height: 70px;
    max-width: 100%;
    vertical-align: middle;
  }
}
.ssRight {
  // width: 240px;
  line-height: 70px;
  display: flex;
  margin-right: 40px;
  .el-select {
    width: 100px;
    height: 30px;
    /deep/ .el-input {
      height: 40px;
    }
    /deep/ .el-input__inner {
      width: 100px;
      height: 40px;
      border: 0;
    }
  }
}
.assets {
  width: 96px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  background: linear-gradient(
    90deg,
    rgba(255, 179, 1, 1) 0%,
    rgba(254, 140, 1, 1) 100%
  );

  border-radius: 16px;
  margin: 20px 20px;
  span {
    color: #fff;
  }
}
.zh {
  // width: 80px;
  height: 40px;
  display: flex;
  margin-right: 60px;
  li:first-child {
    margin-right: 30px;
  }
  li {
    // width: 40px;
    cursor: pointer;
  }
  li:hover {
    color: #fe8c01;
  }
}
.user {
  position: relative;
  p {
    color: #fe8c01;
    cursor: pointer;
    width: auto;
    height: 30px;
    i {
      border-color: #eee #fff #fff #fff;
      border-style: solid;
      border-width: 5px 5px 0 5px;
      height: 0;
      width: 0;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
.user:hover .user_masage {
  display: block;
}
.user_masage {
  width: 150px;
  height: 135px;
  position: absolute;
  z-index: 99999;
  left: 50%;
  top: 50px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 10px 0;
  display: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  li {
    width: 100%;
    height: 35px;
    line-height: 35px;
    margin-bottom: 10px;
    // padding: 10px;
    a {
      display: block;
      padding: 0 10px;
      width: 100%;
    }
    a:hover {
      background: #fffbf4;
      color: #fe8c01;
    }
  }
}
.h_active,
.e_active {
  font-weight: 600;
}
</style>
